import { gql } from "@apollo/client";

export const CREATE_ESQUEMA_CONEXION = gql`
    mutation createEsquemaConexion (
        $idEvaluacion: Int!
        $idUsuario: Int!
        $idsDias: [Int!]!
    ){
        createEsquemaConexion (
            input:{
                idEvaluacion: $idEvaluacion
                idUsuario: $idUsuario
                idsDias: $idsDias
            }
        ){
            fechaAlta
        }
    }
`;